<template>
  <div />
</template>

<script>
import { mapGetters } from "vuex";
import { getters } from "@/store";

export default {
  data() {
    return {
      intervalId: null,
      originalTitle: null
    };
  },
  computed: {
    ...mapGetters([getters.currentIdentification])
  },
  methods: {
    blinkInactiveTab() {
      const blinkTitle = this.$t("identification.new_ident_tab_title");
      if (!document.hasFocus()) {
        clearInterval(this.intervalId);
        this.originalTitle = document.title;
        this.intervalId = setInterval(() => {
          document.title =
            document.title === blinkTitle ? this.originalTitle : blinkTitle;
        }, 1000);
        window.addEventListener("focus", this.stopBlink);
      }
    },
    stopBlink() {
      clearInterval(this.intervalId);
      window.removeEventListener("focus", this.stopBlink);
      if (this.originalTitle) {
        document.title = this.originalTitle;
      }
    }
  },
  beforeDestroy() {
    this.stopBlink();
  },
  watch: {
    "currentIdentification.identificationId"() {
      if (this.currentIdentification?.identificationId) {
        this.blinkInactiveTab();
      } else {
        this.stopBlink();
      }
    }
  }
};
</script>
